


























































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import VehiclesDetails from "@/components/VehiclesDetails.vue";
import SearchFilter from "@/components/Utilities/SearchFilter.vue";
import { Vehicle } from "@/services/Vehicle";
import { DropDownItem } from "@/services/DropDownItem";
import HelpContent from "../HelpContent.vue";
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";

@Component({
  components: {
    VehiclesDetails,
    SearchFilter,
    HelpContent,
    LeftClickOptionMenu
  },
})
export default class VehiclesSearchPage extends Vue {
  firstSearch: boolean = false;
  showLoading: boolean = false;
  loading: boolean = false;
  searchFilter: any = {
    freeText: null,
    groupCode: null,
    description: null,
    model:null,
    builder: null,
    brand:null
  };
  placeholder: string = "Search by code or name";

  filterSelected:boolean = false;

  page: number = 1;
  resultsItems: any = {
    resultPage: new Array<Vehicle>(),
    total: 0,
  };
  idVehicleSelected : string = "";
  vehicleCode: number = 0;
  
  dropDownItemsList: DropDownItem [] = [];

  //pacchetto per menu tasto destro su dettaglio entita'
  leftClickOptionMenuUrl: string = "/vehicles/";
  leftClickOptionMenuUrlArgument: string = "vehicleCode";
  handleClick (event, item) {
    (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
  }

  searchFilterResertEvent() {
    this.resetFilterSearch();
  }
  CheckIsNullOrEmpty(text: string) {
      if (text == null) return true;
      if (text == '') return true;
      return false;
  }

  checkFilters(){
      if (!this.CheckIsNullOrEmpty(this.searchFilter.groupCode)) return true
      if (!this.CheckIsNullOrEmpty(this.searchFilter.description)) return true
      if (!this.CheckIsNullOrEmpty(this.searchFilter.builder)) return true
      if (!this.CheckIsNullOrEmpty(this.searchFilter.model)) return true
      if (!this.CheckIsNullOrEmpty(this.searchFilter.brand)) return true
      return false
  }

  checkFilterParameter(){
    if (this.checkFilters()){
      this.filterSelected = true;
    }
    else{
      this.filterSelected = false;
    }
  }

  openAddModal() {
    if(this.$route.params.id)
    this.$router.push("/vehicles");
    this.$bvModal.show("vehicle-add-modal");
  }

  get VehicleTitle(): string {
    return `Vehicle code: ${this.vehicleCode}`;
  }

  async searchVehicle(filter: any, start: boolean = true) {
    this.showLoading = true;
    if (start == true) this.resetSearch();
    try {
      let results: any = await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/GetVehiclesWithFilter"),
        data: {
          FreeText: filter.freeText,
          Builder: filter.builder,
          Brand: filter.brand,
          Model: filter.model,
          Fuel: filter.fuel,
          Traction: filter.traction,
          CurrentPage: this.page,
        },
        withCredentials: true,
        responseType: "json",
      });
      this.resultsItems.resultPage = this.resultsItems.resultPage.concat(
        results.data.listPage
      );
      this.resultsItems.total = results.data.total;
      this.firstSearch = true;
      if (this.resultsItems.resultPage.length >= this.resultsItems.total)
        this.page = 1;
      else this.page += 1;
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.showLoading = false;
    }
  }

  async getDropDownItemsList(){
    try{
    let response = await axios.get<DropDownItem[]>(General.GetApiUrl('/api/DropDownItem/GetDropDownItems'),{
      responseType: "json",
      withCredentials: true
    });
    if(response.data)
    this.dropDownItemsList = response.data;
    }catch(ex){
      General.HandleError(ex, this);
    }
  }

  openVehicle(vehicle: Vehicle, setRouterId: boolean = true) {
    this.idVehicleSelected = vehicle.idVehicle;
    this.vehicleCode = vehicle.vehicleCode;
    if (setRouterId)
      this.$router.push("/vehicles/" + this.vehicleCode);
    this.showVehicleModalDetail();
  }

  showVehicleModalDetail() {
    this.$bvModal.show("vehicle-detail-modal");
  }

  closeGroup() {
    this.$bvModal.hide("vehicle-detail-modal");
  }
  async mounted() {
    await this.getDropDownItemsList();
    if (this.$route.params.id) {
      let code = this.$route.params.id;
      let results: any = await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/GetVehiclesWithFilter"),
        data: {
          VehicleCode: code,
        },
        withCredentials: true,
        responseType: "json",
      });
      this.openVehicle(results.data.listPage[0], false);
    }
  }
  searchFilterSearchEvent(genericSearch: string) {
    if (genericSearch != null)
      this.searchFilter.freeText = genericSearch;
    
    this.searchVehicle(this.searchFilter, true);
  }

  resetFilterSearch() {
    this.searchFilter.groupCode = null;
    this.searchFilter.description = null;
    this.searchFilter.model = null;
    this.searchFilter.builder = null;
    this.searchFilter.brand = null;
    this.searchFilter.multiSearch = null;
    this.filterSelected = false;
  }

  resetSearch() {
    this.firstSearch = false;
    this.resultsItems.resultPage.splice(0);
    this.page = 1;
  }

  canManageLubTable() {
    return General.CanManageLubTable();
  }
}
